export default {
  mutations: {
    setOperations(state, payload) {
      state.operations = payload;
    },
  },
};
